import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class ProveedoresGruposService {

  private service_url: string;

  constructor( private http: Http,
               private constantsServices: ConstantsService,
               private validatorService: ValidatorService,
               private errorService: ErrorsService,
               private authService: AutenticacionService) {
      this.service_url = constantsServices.apiURL + '/proveedores/grupos';
  }

  public getDefaultSchedule() {
    return {
      'nombre': '',
      'razon':'',
      'telefono': '',
      'proveedores_elementos': []
    };
  }

  public createProveedoresGrupo(data) {
      data = this.refactor(data);
      return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  public updateProveedoresGrupo(data, id) {
    data = this.refactor(data);
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }

  public searchProveedoresGrupos(text, page = null) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&search=' + text + '&page=' + page, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true&search=' + text, this.authService.getAuthHeaders());
  }

  public deleteProveedoresGrupo(id) {
    return this.http.delete(this.service_url + '?id=' + id, this.authService.getAuthHeaders());
  }

  public getProveedoresGrupos(page = null) {

    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true', this.authService.getAuthHeaders());
  }

  public getProveedoresGruposList() {
    return this.http.get(this.service_url, this.authService.getAuthHeaders());
  }

  public refactor(data) {
    data.proveedores_elementos.forEach(element => {
      if (element.proveedores.idProveedores) {
        element.idProveedores = element.proveedores.idProveedores;
      }
    });

    return data;
  }

  public writePermission() {
    return this.authService.hasPermission(5, true);
  }

  public canExport() {
    return this.authService.canExport();
  }

  public export(search) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.service_url + '/exportar?search='+search, options)
    .map((response) => {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob());
      const contentDispositionHeader = response.headers.get('content-disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      link.download = result.replace(/"/g, '');
      document.body.appendChild(link); 
      link.click();
      setTimeout(() => {
        link.remove();
      }, 200);
    });
  }
  
  public validateProveedoresGrupo(data) {
    console.log('validating...', data);
    let error = [];


    // validacion de NOMBRE
    if (!this.validatorService.required(data['nombre'])) {
      error['nombre'] = this.errorService.required;
    } else if (!this.validatorService.max(data['nombre'], 50)) {
      error['nombre'] = this.errorService.max(50);
    }

    // validación de tipo de proveedores
    /*if (!this.validatorService.required(data['descripcion'])) {
      error['descripcion'] = this.errorService.required;
    }*/

    // validación de status
    /*if (!this.validatorService.required(data['status'])) {
      error['status'] = this.errorService.required;
    }*/

    // validacion de RFC-Razon
    if (!this.validatorService.required(data['razon'])) {
      error['razon'] = this.errorService.required;
    } else if (!this.validatorService.max(data['razon'], 15)) {
      error['razon'] = this.errorService.max(15);
    }

    // validacion de TELEFONO
    if (!this.validatorService.required(data['telefono'])) {
      error['telefono'] = this.errorService.required;
    } else if (!this.validatorService.max(data['telefono'], 30)) {
      error['telefono'] = this.errorService.max(30);
    }

    // validacion de PROVEEDORES
    if (!this.validatorService.required(data['proveedores_elementos'])) {
      error['proveedores_elementos'] = this.errorService.required;
    }

    return error;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proveedores-grupos.service.ts